/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Follow_RequestedInputs */

const en_follow_requested = /** @type {(inputs: Follow_RequestedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requested`)
};

const es_follow_requested = /** @type {(inputs: Follow_RequestedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solicitado`)
};

const fr_follow_requested = /** @type {(inputs: Follow_RequestedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demandé`)
};

const de_follow_requested = /** @type {(inputs: Follow_RequestedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angefragt`)
};

const id_follow_requested = /** @type {(inputs: Follow_RequestedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diminta`)
};

/** @type {(inputs: Follow_RequestedInputs) => LocalizedString} */
const ja_follow_requested = en_follow_requested;

/** @type {(inputs: Follow_RequestedInputs) => LocalizedString} */
const zh_follow_requested = en_follow_requested;

/** @type {(inputs: Follow_RequestedInputs) => LocalizedString} */
const ar_follow_requested = en_follow_requested;

/** @type {(inputs: Follow_RequestedInputs) => LocalizedString} */
const it_follow_requested = en_follow_requested;

/** @type {(inputs: Follow_RequestedInputs) => LocalizedString} */
const ru_follow_requested = en_follow_requested;

/** @type {(inputs: Follow_RequestedInputs) => LocalizedString} */
const pt_follow_requested = en_follow_requested;

/** @type {(inputs: Follow_RequestedInputs) => LocalizedString} */
const ko_follow_requested = en_follow_requested;

/**
* | output |
* | --- |
* | "Requested" |
*
* @param {Follow_RequestedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const follow_requested = /** @type {((inputs?: Follow_RequestedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Follow_RequestedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_follow_requested(inputs)
	if (locale === "es") return es_follow_requested(inputs)
	if (locale === "fr") return fr_follow_requested(inputs)
	if (locale === "de") return de_follow_requested(inputs)
	if (locale === "ja") return ja_follow_requested(inputs)
	if (locale === "zh") return zh_follow_requested(inputs)
	if (locale === "ar") return ar_follow_requested(inputs)
	if (locale === "id") return id_follow_requested(inputs)
	if (locale === "it") return it_follow_requested(inputs)
	if (locale === "ru") return ru_follow_requested(inputs)
	if (locale === "pt") return pt_follow_requested(inputs)
	return ko_follow_requested(inputs)
});